import React from 'react';

// Marca <StudySpace/>: os sinais de tag em verde-limão.
export function Brand({ size = 'md', onDark = false, className = '' }) {
  return (
    <span className={`ss-brand ss-brand--${size} ${onDark ? 'ss-brand--dark' : ''} ${className}`}>
      <span className="ss-brand__tag">&lt;</span>
      StudySpace
      <span className="ss-brand__tag">/&gt;</span>
    </span>
  );
}

// Símbolo de infinito usado como marca d'água ("estudo sem limite").
export function InfinityMark({ className = '', strokeWidth = 5.5 }) {
  return (
    <svg className={`ss-infinity ${className}`} viewBox="8 18 48 28" aria-hidden="true">
      <path
        d="M12 32c0-6 4.5-10 10-10 9 0 11 20 20 20 5.5 0 10-4 10-10s-4.5-10-10-10c-9 0-11 20-20 20-5.5 0-10-4-10-10z"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
